export default __webpack_public_path__ + "static/media/teller-bottom.f8fb8f50.png";